var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImagePlaceholder = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A5568",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.3,
  strokeWidth: 6.667,
  d: "M63.333 10H16.667A6.667 6.667 0 0 0 10 16.667v46.666A6.667 6.667 0 0 0 16.667 70h46.666A6.667 6.667 0 0 0 70 63.333V16.667A6.667 6.667 0 0 0 63.333 10Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A5568",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.3,
  strokeWidth: 6.667,
  d: "M30 36.667a6.667 6.667 0 1 0 0-13.334 6.667 6.667 0 0 0 0 13.334ZM70 50 59.713 39.713a6.667 6.667 0 0 0-9.426 0L20 70"
})));
SvgImagePlaceholder.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgImagePlaceholder);
export default ForwardRef;